import React from 'react';

const baseRoutes = [
    {
        path: '/',
        exact: true,
        element: React.lazy(() => import('@/pages')),
    },
    {
        path: '/live-player/:courseId/:resourceId/:liveId/:sourceId',
        exact: true,
        element: React.lazy(() => import('@/pages/live')),
    },
    {
        path: '/season-sharding-report/:projectId',
        exact: true,
        element: React.lazy(() => import('@/pages/season-sharding-report')),
    },
    {
        path: '/learning-record/cma',
        exact: true,
        element: React.lazy(() => import('@/pages/learning-record')),
    },
    {
        path: '/study-report',
        exact: true,
        element: React.lazy(() => import('@/pages/study-report')),
    }
];

export { baseRoutes };
